export const filterChartDataByName = (dataArray, keyName) => {
    const data =
      Array.isArray(dataArray) &&
      dataArray?.map((item) => {
        return item[keyName];
      });
    return data;
  };
  